/* Ryedical — Compare page interactions
   1. Mobile matrix: "See all N rows +" expand/collapse
   2. FAQ accordion: one-open-at-a-time, +/- glyph toggle
*/
(function () {
  'use strict';

  function initMatrixExpand(root) {
    var btns = (root || document).querySelectorAll('.ry-cmpv2-expand-btn');
    btns.forEach(function (btn) {
      if (btn.dataset.ryBound === '1') return;
      btn.dataset.ryBound = '1';
      var cards = btn.parentElement.querySelectorAll('.ry-cmpv2-card');
      var defaultShow = parseInt(btn.dataset.defaultShow, 10) || 3;
      var total = cards.length;
      var expandLabel = btn.dataset.expandLabel || ('See all ' + total + ' rows +');
      var collapseLabel = btn.dataset.collapseLabel || 'Show less −';

      function render(expanded) {
        cards.forEach(function (c, i) {
          if (expanded || i < defaultShow) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
        });
        btn.textContent = expanded ? collapseLabel : expandLabel;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      render(false);
      btn.addEventListener('click', function () {
        var nowExpanded = btn.getAttribute('aria-expanded') !== 'true';
        render(nowExpanded);
      });
    });
  }

  function initFaq(root) {
    var items = (root || document).querySelectorAll('.ry-cmpv2-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.ry-cmpv2-faq__q');
      if (!btn || btn.dataset.ryBound === '1') return;
      btn.dataset.ryBound = '1';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        var siblings = item.parentElement.querySelectorAll('.ry-cmpv2-faq__item.is-open');
        siblings.forEach(function (s) {
          s.classList.remove('is-open');
          var b = s.querySelector('.ry-cmpv2-faq__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    initMatrixExpand(document);
    initFaq(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initMatrixExpand(e.target);
    initFaq(e.target);
  });
})();

